import React, { useMemo } from 'react';
import HotelSearchInformantion from './components/HotelSearchInformation';

export default function SearchInformation({ item, selectedRoom, search }) {
  const Component = HotelSearchInformantion;

  return <Component item={item} selectedRoom={selectedRoom} search={search} />;
}
